import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardText,
  CardHeader,
  Badge
} from "reactstrap";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
} from "../global/browserFunctions";
import Icon from "./Icon";
import { addressUrl } from "../global/url";
import { showNotification } from "../global/notification";
import jquery from "jquery";
import Loader from "./Loader";

class AddressCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressArr: [],
      loading: false,
    };

    this.removeAddress = this.removeAddress.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.fetchAddress();
  }

  removeAddress(e, id) {
    var self = this;
    this.setState({ loading: true });
    var query = "&method=delete&customer=";
    var customer = getCookie("customid");
    query += customer;
    query += "&addressid=" + id;

    jquery
      .ajax({
        url: addressUrl + query,
        Cache: false,
        dataType: "jsonp",
      })
      .done(function (data) {
        self.setState({ loading: false });
        try {
          data = JSON.parse(data);
          if (data[0].responseString == "SUCCESS") {
            showNotification("Done!", "success", "Address removed");
            setTimeout(
              //Timeout is set for user to read success message before redirecting to address page
              function () {
                window.location.reload();
              }.bind(this),
              1800
            );
          } else {
            showNotification(
              "Sorry",
              "danger",
              "An unknown error occurred. Couldn't delete your addresses"
            );
          }
        } catch (error) {
          console.log("error@address", error);
          showNotification(
            "Sorry",
            "danger",
            "An unknown error occurred. Couldn't delete your addresses"
          );
        }
      })
      .fail(function () {
        self.setState({ loading: false });
        showNotification(
          "Sorry",
          "danger",
          "An unknown error occurred. Check your network"
        );
      });
  }

  fetchAddress() {
    var query = "&method=view&customer=";
    var customer = getCookie("customid");
    query += customer;
    var self = this;
    jquery
      .ajax({
        url: addressUrl + query,
        Cache: false,
        dataType: "jsonp",
      })
      .done(function (data) {
        self.setState({ loading: false });
        try {
          data = JSON.parse(data);
          if (data[0].responseString == "SUCCESS") {
            var address = JSON.parse(
              decodeURIComponent(data[0].responseMessage)
            );
            self.setState({ addressArr: address });
            setLocalStorage("Address", JSON.stringify(address));
          } else {
            showNotification(
              "Sorry",
              "danger",
              "An unknown error occurred. Couldn't fetch your addresses"
            );
          }
        } catch (error) {
          console.log("error@address", error);
          showNotification(
            "Sorry",
            "danger",
            "An unknown error occurred. Couldn't fetch your addresses"
          );
        }
      })
      .fail(function () {
        self.setState({ loading: false });
        showNotification(
          "Sorry",
          "danger",
          "An unknown error occurred. Couldn't fetch your addresses"
        );
      });
  }

  render() {
    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <Row>
          {this.state.addressArr.map((eachAddress, index) => (
            <Col lg="6" xl="4" sm="12" key={index}>
              <Card className="mb-5">
                <CardHeader>
                  <h6 className="mb-0 text-muted text-center">
                    Address {index + 1}
                  </h6>
                </CardHeader>
                <CardBody className="py-4">
                  <CardText>
                    <div className="text-sm">{eachAddress.addressee.value}</div>
                    <div className="text-sm">{eachAddress.address1.value}</div>
                    <div className="text-sm">{eachAddress.address2.value}</div>
                    <div className="text-sm">{eachAddress.city.value}</div>
                    <div className="text-sm">
                      {eachAddress.state.value} {eachAddress.zipcode.value}
                    </div>
                    <div className="text-sm">{eachAddress.country.text}</div>
                    <div className="text-sm">{eachAddress.addressphone.value}</div>
                    {eachAddress.isdefaultbilling.value && (<Badge color="primary-light" className="mr-1 mb-2 mt-3"><i className="fas fa-info-circle mr-1" />Default Billing</Badge>)}
                    {eachAddress.isdefaultshipping.value && (<Badge color="primary-light" className="mr-1"><i className="fas fa-info-circle mr-1" />Default Shipping</Badge>)}

                    <div> <a href={`/edit-address?id=` + eachAddress.addressinternalid.value}><Button color="dark" size="sm" className="mr-1 mb-2 mt-3">
                      <i className={`far fa-edit mr-2`} />
                      Edit
                    </Button></a>
                      <Button color="light" size="sm" className="mr-1 mb-2 mt-3" onClick={(e) => this.removeAddress(e, eachAddress.addressinternalid.value)}>
                        <i className={`far fa-delete mr-2`} />
                        Remove
                      </Button></div>
                  </CardText>
                </CardBody>
              </Card>
            </Col>
          ))}

          <Col lg="6" xl="4" sm="12">
            <a href="/edit-address">
              <Card className="mb-5">
                <CardBody className="py-4">
                  <CardText>
                    <div className="text-center">
                      <Icon
                        icon="add-1"
                        className="w-3rem h-3rem mb-5 svg-icon-light text-dark"
                      />
                      <h6 className="mb-0 text-dark text-center">
                        Add New
                      </h6>
                    </div>
                  </CardText>
                </CardBody>
              </Card>
            </a>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default AddressCard;
